var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Tooltip, IconButton as MuiIconButton, CircularProgress, } from '@mui/material';
export var IconButton = function (_a) {
    var children = _a.children, tooltip = _a.tooltip, _b = _a.loading, loading = _b === void 0 ? false : _b, _c = _a.withBorder, withBorder = _c === void 0 ? false : _c, props = __rest(_a, ["children", "tooltip", "loading", "withBorder"]);
    if (loading) {
        props.disabled = true;
    }
    if (withBorder) {
        props.sx = __assign({ border: '2px solid', padding: '3px' }, props.sx ? props.sx : {});
    }
    var component = (_jsx(MuiIconButton, __assign({}, props, { children: loading ? _jsx(CircularProgress, { size: 15 }) : children })));
    if (tooltip && !props.disabled) {
        return _jsx(Tooltip, __assign({ disableInteractive: true, title: tooltip }, { children: component }));
    }
    return component;
};
//# sourceMappingURL=IconButton.js.map